<template>
  <div>
    <div class="period-selector">
      <div class="tile">
        <RadioButtons
          :options="periodOptions"
          :on-change="selectPeriod"
          :selected-id="selectedPeriod.id"
        />
        <div>
          <VButton :on-click="exportUserActivity">
            Export User Activity
          </VButton>
        </div>
        <div>
          <VButton :on-click="usageStatistics">
            Usage statistics
          </VButton>
        </div>
      </div>
    </div>
    <div class="dashboard">
      <div class="left-tiles">
        <div class="tile">
          <ProgressIndicator
            :total="dashboard.usersCount"
            :previous-value="dashboard.previousUsersCount"
            :label="$tc('dashboard.usersCount', dashboard.usersCount)"
            :period="selectedPeriod.id"
          />
        </div>
        <div class="tile">
          <donut v-if="donutDataRaw[0] !== null" :data-raw="donutDataRaw" />
        </div>
        <div class="tile">
          <ProgressIndicator
            :total="dashboard.postsCount"
            :previous-value="dashboard.previousPostsCount"
            :label="$tc('dashboard.postsCount', dashboard.postsCount)"
            :period="selectedPeriod.id"
          />
        </div>
        <div class="tile">
          <ProgressIndicator
            :total="dashboard.likesCount"
            :previous-value="dashboard.previousLikesCount"
            :label="$tc('dashboard.likesCount', dashboard.likesCount)"
            :period="selectedPeriod.id"
          />
        </div>
        <div class="tile">
          <SimpleIndicator
            color="#FFCC19"
            :total="dashboard.ownersCount"
            :label="$tc('dashboard.communityLeadersCount', dashboard.ownersCount)"
          />
        </div>
        <div class="tile">
          <SimpleIndicator
            color="#6E1C3B"
            :total="dashboard.unsignedTcuCount"
            :label="$tc('dashboard.unsignedTcuCount', dashboard.unsignedTcuCount)"
          />
        </div>
        <div class="tile">
          <RankingIndicator
            color="#FFCC19"
            title="Classement par nombre d'utilisateurs"
            :ranking="dashboard.rankingUsers || []"
            label-attribute="name"
            value-attribute="usersCount"
          />
        </div>
        <div class="tile">
          <RankingIndicator
            color="#FFCC19"
            title="Classement par nombre de likes"
            :ranking="dashboard.rankingLikes || []"
            label-attribute="name"
            value-attribute="likesCount"
          />
        </div>
        <div class="tile">
          <RankingIndicator
            color="#FFCC19"
            title="Classement par nombre de posts"
            :ranking="dashboard.rankingPosts || []"
            label-attribute="name"
            value-attribute="postsCount"
          />
        </div>
        <div class="tile">
          <RankingIndicator
            color="#FFCC19"
            title="Classement par nombre de commentaires"
            :ranking="dashboard.rankingComments || []"
            label-attribute="name"
            value-attribute="commentsCount"
          />
        </div>
      </div>
      <div class="right-tiles">
        <div class="tile">
          <TopCommunities :top-communities="dashboard.topCommunities" />
        </div>
        <!-- <div class="tile">
          <TopIndicator :total="dashboard.skillsCount"
                        :total-label="$tc('dashboard.skillsCount', dashboard.skillsCount)"
                        :top-values="dashboard.topSkills"
                        :top-value-name="skill => skill.Skill.name"
                        :top-values-label="$tc('dashboard.topSkills', dashboard.skillsCount)"
          />
        </div> -->
        <div class="tile">
          <TopIndicator
            :total="dashboard.interestsCount"
            :total-label="
              $tc('dashboard.interestsCount', dashboard.interestsCount)
            "
            :top-values="dashboard.topInterests"
            :top-value-name="interest => interest.Interest.name"
            :top-values-label="
              $tc('dashboard.topInterests', dashboard.interestsCount)
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Donut from './Donut'
import ProgressIndicator from './ProgressIndicator'
import SimpleIndicator from './SimpleIndicator'
import TopIndicator from './TopIndicator'
import RadioButtons from '../shared/RadioButtons'
import TopCommunities from './TopCommunities'
import VButton from '../shared/VButton'
import RankingIndicator from './RankingIndicator.vue'

export default {
  name: 'Dashboard',
  components: {
    TopCommunities,
    Donut,
    ProgressIndicator,
    SimpleIndicator,
    TopIndicator,
    RadioButtons,
    VButton,
    RankingIndicator
  },
  created() {
    this.$store.dispatch('fetchDashboard')
  },
  data() {
    let periodOptions = [
      { id: 'day', label: 'Day', value: { amount: 1, unit: 'd' } },
      { id: 'week', label: 'Week', value: { amount: 1, unit: 'w' } },
      { id: 'month', label: 'Month', value: { amount: 1, unit: 'M' } }
    ]
    return {
      periodOptions: periodOptions,
      selectedPeriod: periodOptions[0]
    }
  },
  computed: {
    donutDataRaw() {
      let communitiesCount = this.dashboard.communitiesCount || {}
      return [
        communitiesCount.public || 0,
        communitiesCount.publicBroadcast || 0,
        communitiesCount.private || 0,
        communitiesCount.privateBroadcast || 0
      ]
    },
    ...mapState({
      dashboard: state => state.dashboard.dashboard
    })
  },
  methods: {
    selectPeriod(period) {
      this.selectedPeriod = period
      this.$store.dispatch('updateDashboardPeriod', period.value)
    },
    exportUserActivity() {
      this.$store.dispatch('exportUserActivity')
    },
    usageStatistics() {
      this.$store.dispatch('usageStatistics')
    }
  }
}
</script>

<style scoped lang="scss">
$col: 200px;
$margin: 10px;
$height: 250px;

.period-selector {
  //align-items: flex-start;
  justify-content: space-between;
  margin: auto;
  width: 100vw;

    .tile {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-evenly;

      .radio-button-container{
        margin: 2px;
      }
    }
  }

.dashboard {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100vw;
  margin: auto;
  flex-wrap: wrap;

  @media (max-width: $medium) {
    flex-direction: column-reverse;
    padding-bottom: 40px;
  }

  .left-tiles {
    display: flex;
    flex-wrap: wrap;
    width: 80%;

    @media (max-width: $medium) {
      width: 100%;
    }

    .tile {
      width: 2 * ($col + $margin);

      @media (max-width: $medium) {
          //flex-wrap: nowrap;
          width: 50%;
          width: calc(50% - 2*$margin);
          min-width: calc(280px - 2*$margin)
      }

      @media (max-width: $small) {
        flex-wrap: nowrap;
        width: calc(100% - 2*$margin);
        min-width: calc(280px - 2*$margin)
      }
    }
  }

  .right-tiles {
    display: flex;
    flex-wrap: wrap;
    width: 20%;

    @media (max-width: $medium) {
        flex-direction: row;
        width: 100%;
    }

    .tile {
      width: $col;

      @media (max-width: $medium) {
        flex-wrap: nowrap;
        width: calc(50% - 2*$margin);
        min-width: calc(280px - 2*$margin)
      }

      @media (max-width: $small) {
        flex-wrap: nowrap;
        width: calc(100% - 2*$margin);
        min-width: calc(280px - 2*$margin)
      }
    }
  }
}

.tile {
  background-color: white;
  box-shadow: 2px 2px 8px 0 rgba(69, 69, 69, 0.2);
  margin: $margin;
  padding: 2 * $margin;
  box-sizing: border-box;
}
</style>
